
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30.139","height":"29.575"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 725","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6976","d":"M27.264 1.66h-.555V0h-2.874v1.66h-.555V0h-2.874v1.66h-.552V0H16.98v1.66h-.555V0h-2.871v4.032l1.635 1.139v6.478h-2.352v2.652h-1.084v-2.652H8.554v2.652H7.47v-2.652H4.277v2.652H3.193v-2.652H0v17.925h2.344v-1.66c0-4.639 2.948-8.412 6.57-8.412s6.57 3.773 6.57 8.412v1.66h13.02v-24.4l1.635-1.139V.003h-2.875zm.4 27.074H16.326v-.82c0-5.1-3.325-9.253-7.411-9.253s-7.411 4.151-7.411 9.253v.82H.841V12.49h1.513v2.653H5.12v-2.652h1.512v2.652h2.766v-2.652h1.512v2.652h2.766v-2.652h1.511v2.652h12.478zM28.107.841h1.192v2.752l-1.635 1.139v9.569H16.025V4.732L14.39 3.593V.843h1.192v1.66h2.236V.843h1.192v1.66h2.237V.843h1.192v1.66h2.237V.843h1.192v1.66h2.236z"}}),_c('path',{attrs:{"data-name":"Path 6977","d":"M21.844 5.94a1.189 1.189 0 00-1.19 1.189v2.073h2.379V7.125a1.189 1.189 0 00-1.189-1.185z"}})])])
          )
        }
      }
    